import Papa from "papaparse";
import React, { useEffect, useRef, useState } from "react";
import { adminReqConfig, api } from "../../include/api";
import { CustomColoredDropdown, CustomDropdown, FilterPanel, formatOrderId, formatShortMonthDateYearWithTime, PAYMENT_OPTIONS, STATUS_OPTIONS } from "../../include/function";
import "../../styles/Super.css";
import AdminHeader from "./Header";
import { ChevronDown, X } from "react-feather";
import { useNotification } from "../../Toast/ToastProvider";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ERROR, SUCCESS } from "../../include/constant";

const ShopOrders = ({ from }) => {
  const [fetchLoading, setFetchLoading] = useState(true);
  const [orderData, setOrderData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [orderSummary, setOrderSummary] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const toast = useNotification();
  const [selectedData, setSelectedData] = useState([]);
  const [isFilterPanelOpen, setIsFilterPanelOpen] = useState(false);
  const [expandedRows, setExpandedRows] = useState([]);
  const [convertingOrderId, setConvertingOrderId] = useState(null);
  const [searchParams] = useSearchParams();
  const initialQuery = searchParams.get("q") || "";
  const [searchQuery, setSearchQuery] = useState(initialQuery);

  useEffect(() => {
    const q = searchParams.get("q") || "";
    setSearchQuery(q);
  }, [searchParams]);
  const navigate = useNavigate();

  //Filter options from API
  const [brands, setBrands] = useState([]);
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);

  //Filter values (all optional)
  const [filterValues, setFilterValues] = useState({
    date: "",
    status: "",
    paymentType: "",
    paymentStatus: "",
    customerType: "",
    productId: "",
    brandId: "",
    categoryId: "",
    timePeriod: "",
    fromDate: "",
    toDate: "",
  });

  const EMPTY_FILTERS = {
    date: "",
    status: "",
    paymentType: "",
    paymentStatus: "",
    customerType: "",
    productId: "",
    brandId: "",
    categoryId: "",
    reviewFilter: "",
    timePeriod: "",
    fromDate: "",
    toDate: "",
  };

   // when filter category choose particular brand and product logic ---start---
    const [filteredBrands, setFilteredBrands] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);

    const handleFilterChange = (key, value) => {
      setFilterValues((prev) => {
        const newFilters = { ...prev, [key]: value };

        if (key === "categoryId") {
          newFilters.brandId = "";
          newFilters.productId = "";
        } else if (key === "brandId") {
          newFilters.productId = "";
        }

        return newFilters;
      });
    };
    useEffect(() => {
      if (filterValues.categoryId) {
        const categoryBrands = brands.filter(
          (brand) =>
            brand.categoryId?.toString() === filterValues.categoryId.toString(),
        );
        setFilteredBrands(categoryBrands);
      } else {
        setFilteredBrands(brands); // Show all brands if no category selected
      }
    }, [filterValues.categoryId, brands]);
useEffect(() => {
  let filtered = products;

 if (filterValues.categoryId) {
   filtered = filtered.filter(
     (product) =>
       product.category?.[0]?.categoryId?.toString() ===
       filterValues.categoryId.toString(),
   );
   
  }
  
  if (filterValues.brandId) {
    filtered = filtered.filter(
      (product) =>
        product.brandId?.toString() === filterValues.brandId.toString(),
    );
  }

 

  setFilteredProducts(filtered);
}, [filterValues.categoryId, filterValues.brandId, products]);
  useEffect(() => {
     api
       .get("/category/?flag=exceptHome", adminReqConfig())
       .then((res) => setCategories(res.data.data || []))
       .catch(() => setCategories([]));
    api
      .get("/brand/", adminReqConfig())
      .then((res) => setBrands(res.data.data || []))
      .catch(() => setBrands([]));


    api
      .get("/product/?limit=200", adminReqConfig())
      .then((res) => setProducts(res.data.data || []))
      .catch(() => setProducts([]));
  }, []);
          // ------end-------

  const handleOrderDetailClick = (orderId) => {
    navigate(`/admin/order-details/${orderId}`);
  };

  //Fetch orders with filters
  const getOrders = (filters = {}) => {
    setFetchLoading(true);

    const params = new URLSearchParams();

    // Add non-empty filters
    if (filters.date) params.set("date", filters.date);
    if (filters.fromDate) params.set("fromDate", filters.fromDate);
    if (filters.toDate) params.set("toDate", filters.toDate);
    if (filters.status) params.set("status", filters.status);
    if (filters.paymentStatus)
      params.set("paymentStatus", filters.paymentStatus);
    if (filters.paymentType) params.set("paymentType", filters.paymentType);
    if (filters.customerType) params.set("customerType", filters.customerType);
    if (filters.categoryId) params.set("categoryId", filters.categoryId);
    if (filters.productId) params.set("productId", filters.productId);
    if (filters.brandId) params.set("brandId", filters.brandId);
    if (filters.reviewFilter) params.set("reviewFilter", filters.reviewFilter);

    const url = `/orders/?${params.toString()}`;

    api
      .get(url, adminReqConfig())
      .then((response) => {
        if (response.status === 200) {
          const normalizedData = response.data.data.map((order) => ({
            ...order,
            orderItems: order.orderItems.map((item) => ({
              ...item,
              status: item.status?.toLowerCase(),
            })),
          }));
          setOrderData(normalizedData);
          setFilteredData(normalizedData);
        } else {
           setOrderData([]);
           setFilteredData([]);
        }
      })
      .catch((error) => {
        console.error("Failed to fetch orders:", error);
        setOrderData([]);
        setFilteredData([]);
      })
      .finally(() => setFetchLoading(false));
  };

  //Fetch summary
  const getOrderSummary = () => {
    api
      .get("/orders/?flag=orderSummary", adminReqConfig())
      .then((response) => {
        if (response.status === 200) {
          setOrderSummary(response.data.data);
        }
      })
      .catch(() => setOrderSummary([]));
  };

  //Initial load
  useEffect(() => {
    getOrderSummary();
    getOrders();
  }, []);

  //Search
   useEffect(() => {
     if (!searchQuery.trim()) {
       setFilteredData(orderData);
       return;
     }

     const query = searchQuery.toLowerCase().trim();

     const filtered = orderData.filter((order) => {
       // Helper: Format invoice ID for comparison
       const getFormattedInvoiceId = (ord) => {
         if (!ord?.createTimestamp || !ord?.id) return "ORD--";
         const year = new Date(ord.createTimestamp).getFullYear();
         const yy = String(year).slice(-2);
         const paddedId = String(ord.id).padStart(4, "0");
         return `ORD${yy}-${paddedId}`;
       };

       const invoiceId = getFormattedInvoiceId(order);

       return (
         order.id?.toString().startsWith(query) ||
         invoiceId.toLowerCase().startsWith(query) ||
         order.name?.toLowerCase().startsWith(query) ||
         order.customerName?.toLowerCase().startsWith(query) ||
         order.customerType?.toLowerCase().startsWith(query) ||
         order.orderItems?.some(
           (item) =>
             item.productName?.toLowerCase().startsWith(query) ||
             item.variant?.toLowerCase().startsWith(query),
         )
       );
     });

     setFilteredData(filtered);
     setCurrentPage(1);
   }, [searchQuery, orderData, searchParams]);

  //Pagination logic
  let currentItems = [];
  let totalPage = 1;
  let showingFrom = 0;
  let showingTo = 0;
  if (itemsPerPage === "all") {
    currentItems = filteredData;
    showingFrom = filteredData.length > 0 ? 1 : 0;
    showingTo = filteredData.length;
  } else {
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    totalPage = Math.ceil(filteredData.length / itemsPerPage);
    showingFrom = indexOfFirstItem + 1;
    showingTo = Math.min(indexOfLastItem, filteredData.length);
  }

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  //Close filter panel on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (isFilterPanelOpen && !e.target.closest(".nav-item")) {
        setIsFilterPanelOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isFilterPanelOpen]);

  //Row expand/collapse
  const toggleExpand = (orderId) => {
    setExpandedRows((prev) =>
      prev.includes(orderId)
        ? prev.filter((id) => id !== orderId)
        : [...prev, orderId]
    );
  };

  //Export handlers (CSV)
  const handleDownloadCSV = () => {
    const dataToExport =
      selectedData.length > 0
        ? orderData.filter((order) => selectedData.includes(order.id))
        : orderData;

    if (dataToExport.length === 0) {
      toast({ type: "error", message: "No order data to download" });
      return;
    }

    const csvRows = [];
    let serialNo = 1;

    dataToExport.forEach((order) => {
      const baseOrderInfo = {
        "S.No": serialNo,
        "Order ID": order.id || "-",
        "Customer ID": order.customerId || "-",
        "Customer Name": order.name || "-",
        "Customer Type": order.customerType || "-",
        Phone: order.phoneNumber || "-",
        "Alternate Phone": order.alternatePhoneNumber || "-",
        Email: order.emailId || "-",
        "Order Date": order.createTimestamp
          ? new Date(order.createTimestamp).toLocaleString("en-IN")
          : "-",

        // Delivery Address
        "Delivery Address": order.address || "-",
        "Delivery Locality": order.locality || "-",
        "Delivery Landmark": order.landmark || "-",
        "Delivery City": order.city || "-",
        "Delivery State": order.state || "-",
        "Delivery Pin": order.pin || "-",
        "Address Type": order.addressType || "-",

        // Billing Address (may differ)
        "Billing Address": order.billAddress || "-",
        "Billing Locality": order.billLocality || "-",
        "Billing Landmark": order.billLandmark || "-",
        "Billing City": order.billCity || "-",
        "Billing State": order.billState || "-",
        "Billing Pin": order.billPin || "-",
        "Billing GST": order.billGst || "-",

        // Order Totals
        "Total Items": order.totalItems || 0,
        "Total Amount": order.totalAmount || 0,
        "Total Discount": order.totalDiscount || 0,
        "Total Delivery Charge": order.totalDeliveryCharge || 0,
        "Bill Amount": order.billAmount || 0,
        "Total Points": order.totalPoints || 0,

        // Payment Info
        "Payment Mode": order.orderItems?.[0]?.paymentMode || "-",
        "Payment Status": order.paymentStatus || "-",
        "Payment Info": order.orderItems?.[0]?.paymentInfo || "-",
      };

      if (!order.orderItems || order.orderItems.length === 0) {
        // Order with no items → export header only
        csvRows.push({
          ...baseOrderInfo,
          // Item fields empty
          "Item ID": "",
          "Product ID": "",
          "Product Name": "",
          Variant: "",
          Unit: "",
          Qty: "",
          "Price per Unit": "",
          "Item Amount": "",
          "Discount Mode": "",
          "Discount Value": "",
          "Discount Label": "",
          "Points Earned": "",
          "Main Image URL": "",
          "Item Status": "",
          "Shop ID": "",
        });
        serialNo++;
      } else {
        order.orderItems.forEach((item) => {
          csvRows.push({
            ...baseOrderInfo,

            // Override S.No per item
            "S.No": serialNo++,

            // Item-specific fields
            "Item ID": item.id || "-",
            "Product ID": item.productId || "-",
            "Product Name": item.productName || "-",
            Variant: item.variant || "-",
            Unit: item.unit || "-",
            Qty: item.qty || 0,
            "Price per Unit": item.price || 0,
            "Item Amount": item.amount || 0,
            "Discount Mode": item.discountMode || "-",
            "Discount Value": item.discountValue || 0,
            "Discount Label": item.discountLabel || "-",
            "Points Earned": item.points || 0,
            "Main Image URL": item.mainImage || "-",
            "Item Status": item.status || "-",
            "Shop ID": item.shopId || "-",
          });
        });
      }
    });

    const columns = [
      "S.No",
      "Order ID",
      "Customer ID",
      "Customer Name",
      "Customer Type",
      "Phone",
      "Alternate Phone",
      "Email",
      "Order Date",

      // Delivery Address
      "Delivery Address",
      "Delivery Locality",
      "Delivery Landmark",
      "Delivery City",
      "Delivery State",
      "Delivery Pin",
      "Address Type",

      // Billing Address
      "Billing Address",
      "Billing Locality",
      "Billing Landmark",
      "Billing City",
      "Billing State",
      "Billing Pin",
      "Billing GST",

      // Order Totals
      "Total Items",
      "Total Amount",
      "Total Discount",
      "Total Delivery Charge",
      "Bill Amount",
      "Total Points",

      // Payment
      "Payment Mode",
      "Payment Status",
      "Payment Info",

      // Item
      "Item ID",
      "Product ID",
      "Product Name",
      "Variant",
      "Unit",
      "Qty",
      "Price per Unit",
      "Item Amount",
      "Discount Mode",
      "Discount Value",
      "Discount Label",
      "Points Earned",
      "Main Image URL",
      "Item Status",
      "Shop ID",
    ];

    const csv = Papa.unparse({
      fields: columns,
      data: csvRows.map((row) => columns.map((col) => row[col])),
    });

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "orders_list.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  //Selection handlers
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allIds = currentItems.map((p) => p.id);
      setSelectedData((prev) => [...new Set([...prev, ...allIds])]);
    } else {
      const idsToRemove = currentItems.map((p) => p.id);
      setSelectedData((prev) => prev.filter((id) => !idsToRemove.includes(id)));
    }
  };
  const handleSelectOne = (id) => {
    setSelectedData((prev) =>
      prev.includes(id) ? prev.filter((pid) => pid !== id) : [...prev, id]
    );
  };
  
  const convertToInvoice = (order) => {
    if (!order?.id || !order?.customerId) {
      toast({ type: ERROR, message: "OrderId and CustomerId required" });
      return;
    }

    setConvertingOrderId(order.id);

    const payload = {
      customerId: order.customerId,
      invoiceStatus: "yes",
      invoiceId: generateNumericId(),
    };

    api
      .put(
        `/order_for_super/?id=${order.id}&flag=changeInvoice`,
        payload,
        adminReqConfig()
      )
      .then((response) => {
        if (response.status === 200) {
          toast({
            type: SUCCESS,
            message: "Successfully converted to invoice",
          });
          getOrders();
        } else {
          toast({ type: ERROR, message: "Failed to convert to invoice" });
        }
      })
      .catch((error) => {
        console.error("Conversion error:", error);
        toast({ type: ERROR, message: "Error converting order to invoice." });
      })
      .finally(() => {
        setConvertingOrderId(null);
      });
  };

  // Helper function to generate a numeric-only ID
  const generateNumericId = () => {
    const chars = "0123456789";
    let id = "";
    for (let i = 0; i < 10; i++) {
      // Adjust length as needed
      id += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return id;
  };

  //Apply & Clear filters
  const applyFilters = () => {
    let finalFilters = { ...filterValues };

    // Handle timePeriod presets
    if (filterValues.timePeriod && filterValues.timePeriod !== "period") {
      const now = new Date();
      let fromDate = "";
      let toDate = "";

      switch (filterValues.timePeriod) {
        case "today":
          fromDate = toDate = now.toISOString().split("T")[0];
          break;
        case "yesterday":
          const yesterday = new Date(now);
          yesterday.setDate(now.getDate() - 1);
          fromDate = toDate = yesterday.toISOString().split("T")[0];
          break;
        case "thisMonth":
          fromDate = `${now.getFullYear()}-${String(
            now.getMonth() + 1
          ).padStart(2, "0")}-01`;
          toDate = now.toISOString().split("T")[0];
          break;
        case "last3Months":
          const threeMonthsAgo = new Date(now);
          threeMonthsAgo.setMonth(now.getMonth() - 3);
          fromDate = threeMonthsAgo.toISOString().split("T")[0];
          toDate = now.toISOString().split("T")[0];
          break;
        case "thisYear":
          fromDate = `${now.getFullYear()}-01-01`;
          toDate = `${now.getFullYear()}-12-31`;
          break;
        case "all":
        default:
          fromDate = toDate = "";
      }

      finalFilters = {
        ...finalFilters,
        fromDate,
        toDate,
      };
    }

    // Clear the old `date` filter if using range
    if (finalFilters.timePeriod) {
      finalFilters.date = ""; // because backend uses either `date` OR `fromDate/toDate`
    }

    getOrders(finalFilters);
    setIsFilterPanelOpen(false);
  };
  const clearFilters = () => {
    const empty = {
      date: "",
      fromDate: "",
      toDate: "",
      status: "",
      paymentType: "",
      paymentStatus: "",
      customerType: "",
      productId: "",
      brandId: "",
      categoryId: "",
      timePeriod: "",
    };
    setFilterValues(empty);
    getOrders(empty);
    setIsFilterPanelOpen(false);
  };

  return (
    <>
      <AdminHeader title={"ORDERS LIST"}>
        <div className="content-wrapper p-0">
          <section
            style={{
              backgroundColor: "#F1F4F9",
              padding: "30px",
              marginTop: "70px",
              marginBottom: "40px",
              minHeight: "80vh",
            }}
          >
            {/* Summary Cards */}
            <div className="summary-cards-section mb-24">
              {orderSummary?.length > 0 &&
                (() => {
                  const sum = orderSummary[0];
                  return (
                    <div className="row g-3">
                      <div className="col-md-3">
                        <div
                          className="order-list-card shadow-sm"
                          onClick={() => {
                            const newFilters = {
                              ...filterValues,
                              status: "ordered",
                            };
                            setFilterValues(newFilters);
                            getOrders(newFilters);
                          }}
                          style={{
                            cursor: "pointer",
                            transition: "box-shadow 0.2s",
                            userSelect: "none",
                          }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.boxShadow =
                              "0 4px 12px rgba(250, 29, 29, 0.15)")
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.boxShadow = "")
                          }
                        >
                          <div className="d-flex justify-content-between">
                            <div>
                              <p className="mb-1">Orders Received</p>
                              <p className="mb-0 order-list-amnt">
                                {sum.orderedCount || 0}
                              </p>
                            </div>
                            <div className="order-list-card-image p-2">
                              <img
                                src="/assets/images/ord-recieved.png"
                                style={{ height: "40px", width: "40px" }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div
                          className="order-list-card shadow-sm"
                          onClick={() => {
                            const newFilters = {
                              ...filterValues,
                              status: "packed",
                            };
                            setFilterValues(newFilters);
                            getOrders(newFilters);
                          }}
                          style={{
                            cursor: "pointer",
                            transition: "box-shadow 0.2s",
                            userSelect: "none",
                          }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.boxShadow =
                              "0 4px 12px rgba(250, 29, 29, 0.15)")
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.boxShadow = "")
                          }
                        >
                          {" "}
                          <div className="d-flex justify-content-between">
                            <div>
                              <p className="mb-1">Orders Packed</p>
                              <p className="mb-0 order-list-amnt">
                                {sum.packedCount || 0}
                              </p>
                            </div>
                            <div className="order-list-card-image p-2">
                              <img
                                src="/assets/images/ord-packed.png"
                                style={{ height: "40px", width: "40px" }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div
                          className="order-list-card shadow-sm"
                          onClick={() => {
                            const newFilters = {
                              ...filterValues,
                              status: "shipped",
                            };
                            setFilterValues(newFilters);
                            getOrders(newFilters);
                          }}
                          style={{
                            cursor: "pointer",
                            transition: "box-shadow 0.2s",
                            userSelect: "none",
                          }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.boxShadow =
                              "0 4px 12px rgba(250, 29, 29, 0.15)")
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.boxShadow = "")
                          }
                        >
                          {" "}
                          <div className="d-flex justify-content-between">
                            <div>
                              <p className="mb-1">Orders Shipped</p>
                              <p className="mb-0 order-list-amnt">
                                {sum.shippedCount || 0}
                              </p>
                            </div>
                            <div className="order-list-card-image p-2">
                              <img
                                src="/assets/images/ord-shipped.png"
                                style={{ height: "40px", width: "40px" }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div
                          className="order-list-card shadow-sm"
                          onClick={() => {
                            const newFilters = {
                              ...filterValues,
                              status: "delivered",
                            };
                            setFilterValues(newFilters);
                            getOrders(newFilters);
                          }}
                          style={{
                            cursor: "pointer",
                            transition: "box-shadow 0.2s",
                            userSelect: "none",
                          }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.boxShadow =
                              "0 4px 12px rgba(250, 29, 29, 0.15)")
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.boxShadow = "")
                          }
                        >
                          {" "}
                          <div className="d-flex justify-content-between">
                            <div>
                              <p className="mb-1">Orders Delivered</p>
                              <p className="mb-0 order-list-amnt">
                                {sum.deliveredCount || 0}
                              </p>
                            </div>
                            <div className="order-list-card-image p-2">
                              <img
                                src="/assets/images/ord-delivered.png"
                                style={{ height: "40px", width: "40px" }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div
                          className="order-list-card shadow-sm"
                          onClick={() => {
                            const newFilters = {
                              ...EMPTY_FILTERS,
                              paymentStatus: "paid",
                            };
                            setFilterValues(newFilters);
                            getOrders(newFilters);
                          }}
                          style={{
                            cursor: "pointer",
                            transition: "box-shadow 0.2s",
                            userSelect: "none",
                          }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.boxShadow =
                              "0 4px 12px rgba(250, 29, 29, 0.15)")
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.boxShadow = "")
                          }
                        >
                          <div className="d-flex justify-content-between">
                            <div>
                              <p className="mb-1">Received Payment</p>
                              <p className="mb-0 order-list-amnt">
                                ₹
                                {Number(
                                  sum.totalPaidAmount || 0,
                                ).toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </p>
                            </div>
                            <div className="order-list-card-image p-2">
                              <img
                                src="/assets/images/recieved-pay.png"
                                style={{ height: "40px", width: "40px" }}
                                alt="Received Payment"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div
                          className="order-list-card shadow-sm"
                          onClick={() => {
                            const newFilters = {
                              ...EMPTY_FILTERS,
                              paymentStatus: "pending,partially-paid",
                            };
                            setFilterValues(newFilters);
                            getOrders(newFilters);
                          }}
                          style={{
                            cursor: "pointer",
                            transition: "box-shadow 0.2s",
                            userSelect: "none",
                          }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.boxShadow =
                              "0 4px 12px rgba(21, 20, 20, 0.15)")
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.boxShadow = "")
                          }
                        >
                          <div className="d-flex justify-content-between">
                            <div>
                              <p className="mb-1">Pending Payment</p>
                              <p className="mb-0 order-list-amnt">
                                ₹
                                {Number(
                                  sum.totalPendingAmount || 0,
                                ).toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </p>
                            </div>
                            <div className="order-list-card-image p-2">
                              <img
                                src="/assets/images/pending-pay.png"
                                style={{ height: "40px", width: "40px" }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div
                          className="order-list-card shadow-sm"
                          onClick={() => {
                            const newFilters = {
                              ...EMPTY_FILTERS,
                              reviewFilter: "published",
                            };
                            setFilterValues(newFilters);
                            getOrders(newFilters);
                          }}
                          style={{
                            cursor: "pointer",
                            transition: "box-shadow 0.2s",
                            userSelect: "none",
                          }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.boxShadow =
                              "0 4px 12px rgba(21, 20, 20, 0.15)")
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.boxShadow = "")
                          }
                        >
                          <div className="d-flex justify-content-between">
                            <div>
                              <p className="mb-1">Published Reviews</p>
                              <p className="mb-0 order-list-amnt">
                                {sum.totalReviews || 0}
                              </p>
                            </div>
                            <div className="order-list-card-image p-2">
                              <img
                                src="/assets/images/publised-rev.png"
                                style={{ height: "40px", width: "40px" }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div
                          className="order-list-card shadow-sm"
                          onClick={() => {
                            const newFilters = {
                              ...EMPTY_FILTERS,
                              reviewFilter: "pending",
                            };
                            setFilterValues(newFilters);
                            getOrders(newFilters);
                          }}
                          style={{
                            cursor: "pointer",
                            transition: "box-shadow 0.2s",
                            userSelect: "none",
                          }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.boxShadow =
                              "0 4px 12px rgba(21, 20, 20, 0.15)")
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.boxShadow = "")
                          }
                        >
                          <div className="d-flex justify-content-between">
                            <div>
                              <p className="mb-1">Pending Reviews</p>
                              <p className="mb-0 order-list-amnt">
                                {sum.pendingReviews || 0}
                              </p>
                            </div>
                            <div className="order-list-card-image p-2">
                              <img
                                src="/assets/images/pending-rev.png"
                                style={{ height: "40px", width: "40px" }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })()}
            </div>

            <>
              <div className="rounded-5 bg-white py-24">
                <div className="row align-items-center px-24 py-10 mb-3">
                  <div className="col-auto">
                    <h6 className="mb-0">All Orders List</h6>
                  </div>
                  <div className="col d-flex align-items-center">
                    <div className="nav-item" style={{ position: "relative" }}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          border: "1px solid #c6d6f5",
                          borderRadius: "8px",
                          backgroundColor: "#fff",
                          width: "500px",
                        }}
                      >
                        <img
                          src="/assets/images/search-icon.png"
                          style={{ width: "18px", marginLeft: "8px" }}
                        />
                        <input
                          type="text"
                          placeholder="Filter and search here..."
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                          onFocus={() => setIsFilterPanelOpen(true)}
                          style={{
                            border: "none",
                            outline: "none",
                            padding: "8px 8px",
                            width: "100%",
                            fontSize: "14px",
                            color: "#333",
                            backgroundColor: "transparent",
                          }}
                        />
                         {searchQuery && (
                                                  <X
                                                    size={24}
                                                    onClick={(e) => {
                                                      e.stopPropagation(); 
                                                      setSearchQuery(""); 
                                                      setCurrentPage(1);
                                                      setIsFilterPanelOpen(false);
                                                    }}
                                                    style={{
                                                      position: "absolute",
                                                      right: "40px", 
                                                      cursor: "pointer",
                                                      color: "#999",
                                                      padding: "4px",
                                                      zIndex: 10,
                                                    }}
                                                    onMouseEnter={(e) =>
                                                      (e.currentTarget.style.color = "#666")
                                                    }
                                                    onMouseLeave={(e) =>
                                                      (e.currentTarget.style.color = "#999")
                                                    }
                                                  />
                                                )}
                        <ChevronDown
                          size={16}
                          style={{
                            marginRight: "8px",
                            color: "#999",
                            cursor: "pointer",
                            transform: isFilterPanelOpen
                              ? "rotate(180deg)"
                              : "rotate(0deg)",
                            transition: "transform 0.2s",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setIsFilterPanelOpen(!isFilterPanelOpen);
                          }}
                        />
                      </div>
                      {isFilterPanelOpen && (
                        <FilterPanel
                          filterValues={filterValues}
                          onFilterChange={handleFilterChange}
                          onApply={applyFilters}
                          onClear={clearFilters}
                          brands={brands}
                          categories={categories}
                          products={products}
                          filteredBrands={filteredBrands}
                          filteredProducts={filteredProducts}
                        />
                      )}
                    </div>
                  </div>
                  <div className="d-flex col-auto">
                    <CustomDropdown handleDownloadCSV={handleDownloadCSV} />
                  </div>
                </div>

                {/* Table */}
                <div className="table-responsive mt-24 product-table">
                  <table className="table table-striped custom-striped-table-product-list align-middle">
                    <thead>
                      <tr>
                        <th scope="col">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            style={{ borderColor: "#c5d5f5" }}
                            onChange={handleSelectAll}
                            checked={
                              currentItems.length > 0 &&
                              currentItems.every((p) =>
                                selectedData.includes(p.id),
                              )
                            }
                          />
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Order ID
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Product Name
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Customer Name
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Customer Type
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Date & Time
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Quantity
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Total Amount
                        </th>

                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Payment Status
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Delivery Address
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Status
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentItems.length > 0 ? (
                        currentItems.map((order) => {
                          const isMulti = order.orderItems.length > 1;
                          const isExpanded = expandedRows.includes(order.id);
                          const currentCredit =
                            Number(order?.currentCredit) || 0;
                          const creditBal = Number(order?.creditBal) || 0;

                          const isOverdue =
                            order?.orderItems[0]?.status.toLowerCase() ===
                            "need-approval";
                          return (
                            <React.Fragment key={order.id}>
                              <tr
                                className={
                                  isOverdue ? "overdue-row" : undefined
                                }
                              >
                                <td>
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    style={{ borderColor: "#c5d5f5" }}
                                    checked={selectedData.includes(order.id)}
                                    onChange={() => handleSelectOne(order.id)}
                                  />
                                </td>
                                <td>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "6px",
                                      textWrap: "nowrap",
                                    }}
                                  >
                                    {order.orderItems.length > 1 && (
                                      <button
                                        style={{
                                          border: "2px solid #006fbf",
                                          color: "#006fbf",
                                          background: "transparent",
                                          borderRadius: "4px",
                                          width: "14px",
                                          height: "14px",
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          fontSize: "12px",
                                          cursor: "pointer",
                                        }}
                                        onClick={() => toggleExpand(order.id)}
                                      >
                                        {isExpanded ? "−" : "+"}
                                      </button>
                                    )}
                                    <span
                                      className={
                                        isOverdue ? "over-due-color" : undefined
                                      }
                                    >
                                      {formatOrderId(order)}
                                    </span>
                                  </div>
                                </td>
                                <td style={{ width: "15%" }}>
                                  <button
                                    onClick={() =>
                                      handleOrderDetailClick(order.id)
                                    }
                                    style={{
                                      background: "none",
                                      border: "none",
                                      // color: "#006fbf",
                                      // textDecoration: "underline",
                                      cursor: "pointer",
                                      padding: 0,
                                      fontSize: "inherit",
                                    }}
                                    title="View Order Details"
                                  >
                                    {isMulti ? (
                                      <>
                                        <span
                                          className={
                                            isOverdue
                                              ? "over-due-color"
                                              : undefined
                                          }
                                        >
                                          {order.orderItems[0]?.productName}
                                        </span>
                                        <span
                                          className={
                                            isOverdue
                                              ? "over-due-color"
                                              : "text-primary"
                                          }
                                        >
                                          {" "}
                                          + {order.orderItems.length - 1} Items
                                        </span>
                                      </>
                                    ) : (
                                      <span
                                        className={
                                          isOverdue
                                            ? "over-due-color"
                                            : undefined
                                        }
                                      >
                                        {order.orderItems[0]?.productName}
                                      </span>
                                    )}
                                  </button>
                                </td>

                                <td>
                                  <span
                                    className={
                                      isOverdue ? "over-due-color" : undefined
                                    }
                                  >
                                    {order.name}
                                  </span>
                                </td>
                                <td>
                                  <span
                                    className={
                                      isOverdue ? "over-due-color" : undefined
                                    }
                                  >
                                    {order.customerType
                                      ? `${order.customerType} (${
                                          order.customerType === "individual"
                                            ? "B2C"
                                            : "B2B"
                                        })`
                                      : "N/A"}
                                  </span>
                                </td>
                                <td>
                                  <span
                                    className={
                                      isOverdue ? "over-due-color" : undefined
                                    }
                                  >
                                    {formatShortMonthDateYearWithTime(
                                      order.createTimestamp,
                                    )}
                                  </span>
                                </td>
                                <td>
                                  <span
                                    className={
                                      isOverdue ? "over-due-color" : undefined
                                    }
                                  >
                                    {order.totalItems}
                                  </span>
                                </td>
                                <td>
                                  <span
                                    className={
                                      isOverdue ? "over-due-color" : undefined
                                    }
                                  >
                                    ₹
                                    {Math.round(
                                      order.totalAmount,
                                    ).toLocaleString()}
                                  </span>
                                </td>
                                <td>
                                  {order.paymentStatus && (
                                    <CustomColoredDropdown
                                      value={order.paymentStatus}
                                      options={PAYMENT_OPTIONS}
                                      type="payment"
                                      disable={true}
                                    />
                                  )}
                                </td>
                                <td>
                                  <span
                                    className={
                                      isOverdue ? "over-due-color" : undefined
                                    }
                                  >
                                    {order.address}, {order.locality},{" "}
                                    {order.city},{order.state}
                                  </span>
                                </td>
                                <td>
                                  {!isMulti && order.orderItems[0]?.status && (
                                    <CustomColoredDropdown
                                      value={order.orderItems[0]?.status}
                                      options={STATUS_OPTIONS}
                                      type="status"
                                      disable={true}
                                    />
                                  )}
                                </td>
                                <td>
                                  {order.invoiceStatus === "yes" ? (
                                    <button
                                      disabled
                                      style={{
                                        minWidth: "120px",
                                        fontSize: "15px",
                                        color: "#007AC3",
                                        backgroundColor: "#D9EBFF",
                                        borderRadius: "6px",
                                        cursor: "not-allowed",
                                        opacity: 0.7,
                                      }}
                                    >
                                      Invoice Converted
                                    </button>
                                  ) : (
                                    <button
                                      onClick={() => convertToInvoice(order)}
                                      disabled={convertingOrderId === order.id} // ✅ disable during loading
                                      style={{
                                        minWidth: "120px",
                                        fontSize: "15px",
                                        color: "white",
                                        backgroundColor:
                                          convertingOrderId === order.id
                                            ? "#999"
                                            : "#2B95D3", // ✅ gray during loading
                                        borderRadius: "6px",
                                        cursor:
                                          convertingOrderId === order.id
                                            ? "not-allowed"
                                            : "pointer",
                                      }}
                                    >
                                      {convertingOrderId === order.id
                                        ? "Converting..."
                                        : "Convert to invoice"}
                                    </button>
                                  )}
                                </td>
                              </tr>
                              {isExpanded &&
                                order.orderItems.map((item, idx) => (
                                  <tr key={item.id} className="bg-light">
                                    <td></td>
                                    <td style={{ paddingLeft: "30px" }}>
                                      {idx + 1}.
                                    </td>
                                    <td>
                                      {item.productName || "N/A"} 
                                      {item.variant !== "" ? "(" : ""} 
                                      {item.variant ? item.variant : ""} 
                                      {item.variant !== "" ? ")" : ""}
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>{item.qty}</td>
                                    <td>
                                      ₹
                                      {Math.round(item.amount).toLocaleString()}
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <td>
                                      {item.status && (
                                        <CustomColoredDropdown
                                          value={item.status}
                                          options={STATUS_OPTIONS}
                                          type="status"
                                          disable={true}
                                        />
                                      )}
                                    </td>
                                  </tr>
                                ))}
                            </React.Fragment>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="12" className="text-center py-4">
                            <div className="text-muted">
                              {fetchLoading ? (
                                <div
                                  className="spinner-border spinner-border-sm"
                                  role="status"
                                >
                                  <span className="visually-hidden">
                                    Loading...
                                  </span>
                                </div>
                              ) : filteredData.length === 0 &&
                                orderData.length > 0 ? (
                                "No orders match your filters"
                              ) : (
                                "No orders found"
                              )}
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {/* Pagination */}
                <div className="d-flex justify-content-between align-items-center mt-16 p-16">
                  <div className="d-flex align-items-center">
                    <select
                      className="form-select d-inline-block w-auto"
                      value={itemsPerPage}
                      onChange={(e) => {
                        const val = e.target.value;
                        setItemsPerPage(val === "all" ? "all" : parseInt(val));
                        setCurrentPage(1);
                      }}
                      style={{
                        height: "34px",
                        fontSize: "14px",
                        minWidth: "70px",
                      }}
                    >
                      <option value="20">20</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="all">All</option>
                    </select>
                    <span className="ms-2">
                      Showing {showingFrom} to {showingTo} of{" "}
                      {filteredData.length} orders
                    </span>
                  </div>
                  <nav>
                    <ul className="pagination mt-0">
                      <li
                        className={`page-item ${
                          currentPage === 1 ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => paginate(currentPage - 1)}
                        >
                          &laquo;
                        </button>
                      </li>
                      {(() => {
                        const pagesToShow = 5;
                        let startPage = Math.max(
                          1,
                          currentPage - Math.floor(pagesToShow / 2),
                        );
                        let endPage = startPage + pagesToShow - 1;
                        if (endPage > totalPage) {
                          endPage = totalPage;
                          startPage = Math.max(1, endPage - pagesToShow + 1);
                        }
                        const pageNumbers = [];
                        for (let i = startPage; i <= endPage; i++) {
                          pageNumbers.push(i);
                        }
                        return pageNumbers.map((pageNum) => (
                          <li
                            key={pageNum}
                            className={`page-item ${
                              currentPage === pageNum ? "active" : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={() => paginate(pageNum)}
                            >
                              {pageNum}
                            </button>
                          </li>
                        ));
                      })()}
                      <li
                        className={`page-item ${
                          currentPage === totalPage ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => paginate(currentPage + 1)}
                        >
                          &raquo;
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </>
          </section>
        </div>
      </AdminHeader>
    </>
  );
};

export default ShopOrders;
